import React from 'react';
import PropTypes from 'prop-types';

import { IComponent } from '../../../typings/generic-component';
import './tooltip.scss';
import { IClassNames, makeClassNames } from '../../../utils/styles';

export interface ITooltip extends IComponent {
  text: React.ReactNode;
}

const classNames = (className: string): IClassNames =>
  makeClassNames({
    tooltip: `tooltip ${className}`,
    tooltipText: 'tooltip__text',
  });

const Tooltip: React.FC<ITooltip> = ({ children, text, className = '' }) => {
  const cn = classNames(className);

  return (
    <span className={cn.tooltip}>
      <span className={cn.tooltipText}>{text}</span>
      {children}
    </span>
  );
};

/* istanbul ignore else */ if (process.env.NODE_ENV !== 'production') {
  Tooltip.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    text: PropTypes.node.isRequired,
  };
}

export default Tooltip;
